export const Tools = {
	formatPrice(price, currency = 'RUB', useTemplate = false) {
		return window.BX.Currency.currencyFormat(price, currency, useTemplate);
	},

	snakeToCamel(value) {
		return value.toLowerCase().replace(/([-_][a-z])/g, group =>
			group
				.toUpperCase()
				.replace('-', '')
				.replace('_', '')
		);
	},

	join(arr, separator = ', ') {
		return arr
			.filter((n) => n)
			.join(separator);
	},

	isBasketItemsEqual(basketItemA, basketItemB) {
		for (const [code] of Object.entries(basketItemA)) {
			if (code === 'dateUpdate')
				continue;

			let valueA = basketItemA[code];
			if (typeof valueA === 'object' && valueA !== null)
				valueA = JSON.stringify(valueA);
			let valueB = basketItemB[code];
			if (typeof valueB === 'object' && valueB !== null)
				valueB = JSON.stringify(valueB);

			if (valueA !== valueB) {
				return false;
			}
		}

		return true;
	}
};
